import { createContext, useContext } from 'react';

import {
  type AdaptiveLearningPlan,
  DEFAULT_TIME_COMMITMENT,
  type LearningBlock,
  type TimeCommitment,
} from 'bundles/adaptive-learning-common/types';

export type AdaptiveLearningContextType = {
  show: boolean;
  setShow: (show: boolean) => void;
  adaptivePlan?: AdaptiveLearningPlan;
  timeCommitment: TimeCommitment;
  getLearningBlock: (itemId: string) => LearningBlock | undefined;
  getProgress: (itemId: string) => number;
  updateLearningPath: (options: { timeCommitment: TimeCommitment }) => void;
  updatePlan: (plan: AdaptiveLearningPlan) => void;
  regeneratePlan: (timeCommitment: number) => Promise<void>;
};

export const AdaptiveLearningContext = createContext<AdaptiveLearningContextType>({
  show: false,
  setShow: () => undefined,
  timeCommitment: DEFAULT_TIME_COMMITMENT,
  getLearningBlock: () => undefined,
  getProgress: () => 0,
  updateLearningPath: () => undefined,
  updatePlan: () => undefined,
  regeneratePlan: () => Promise.resolve(),
});

export const useAdaptiveLearningContext = () => useContext(AdaptiveLearningContext);
